// Shared with Hooks/useKeyPress: detects whether a keyboard event's target
// is a free-text editing surface (textarea / contentEditable), so plain
// (non-modifier) shortcuts don't hijack typing.
export const isMultilineEditorTarget = (target) => {
  if (!target) return false;
  if (target.tagName === 'TEXTAREA') return true;
  if (target.isContentEditable) return true;

  return Boolean(target.closest?.('[contenteditable="true"]'));
};

// Broader check used by the shortcuts scope stack: any regular form field
// (input/select/textarea/contentEditable), so unmodified single-key combos
// (e.g. "[", "]") don't fire while the user is typing in a filter or field.
export const isEditableTarget = (target) => {
  if (!target) return false;
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return true;

  return isMultilineEditorTarget(target);
};
